export default __webpack_public_path__ + "static/media/gallery-wip-handle_07.6a67c579.jpg";